import { render, staticRenderFns } from "./TVShow2.vue?vue&type=template&id=dfa52284&scoped=true&"
import script from "./TVShow2.vue?vue&type=script&lang=js&"
export * from "./TVShow2.vue?vue&type=script&lang=js&"
import style0 from "./TVShow2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TVShow2.vue?vue&type=style&index=1&id=dfa52284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa52284",
  null
  
)

export default component.exports